<form class="text-area-wrapper" [formGroup]="form">

	<div [ngClass]="{'with-description': description}">
		@if (!!label) {
			<label for="{{htmlId()}}">{{ label }}</label>
		}
		@if (description && !isMobile()) {
			<svg-icon src="assets/icons/info.svg" class="info-icon" [nbPopover]="explanationPopover" nbPopoverPlacement="left"></svg-icon>
		}
		@if (description && isMobile()) {
			<svg-icon src="assets/icons/info.svg" class="info-icon" (click)="showExplanationDialog(explanationDialog)"></svg-icon>
		}
	</div>

	<textarea class="textarea" #textAreaElement [id]="htmlId()" nbInput [placeholder]="!!placeholder ? placeholder : ''" fullWidth [formControlName]="fullControlName()"
			  [attr.formcontrolname]="fullControlName()"
			  [attr.data-test-id]="dataTestId"
			  [ngClass]="{'invalid' : isInvalid()}" (keyup)="autoGrowEnabled && autoGrow()" autocomplete="user-password"></textarea>
	@if (isInvalid()) {
		<div class="validation-message">{{ getValidationErrors() | async }}</div>
	}
</form>

<ng-template #explanationPopover>
	@if (!isMobile()) {
		<nb-card class="description-card">
			<nb-card-body class="description-body">
				<div>
					<div class="label" [innerHTML]="description"></div>
					<nb-icon class="close-icon" icon="close-circle-outline" (click)="popover.hide()"></nb-icon>
				</div>
			</nb-card-body>
		</nb-card>
	}
</ng-template>

<ng-template #explanationDialog let-infoDialog="dialogRef">
	@if (isMobile()) {
		<nb-card class="description-card mobile">
			<nb-card-header class="header">
				<nb-icon [icon]="'close-outline'" [options]="{ width: '30px' }" (click)="infoDialog.close()"></nb-icon>
			</nb-card-header>
			<nb-card-body class="description-body">
				<div>
					<div class="label" [innerHTML]="description"></div>
				</div>
			</nb-card-body>
		</nb-card>
	}
</ng-template>
